module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAASxJREFUOE/tk71KA0EUhb9rNskWPoGNydrY+RiKQVRQBAULBUsLQYRUU+UFbAXBHwQrwUoUBEF8BiHELSQgljEmTpErRoT87ibZLZ1ymPnOnXPOCDEviZnHPzC6oyN5qDskyWTPQKYlX5ppHWNooBocUt4FsAJcSb60HAhUk3HBt2JodBqglyQoZs9B1kBuGJdF2S1+BQMLng/ygq3lxJQ//w6rYYyUdwJsAHfYxoIYv94p2vVkLXhHwDZwj2tzsvdaa8LSU8eobrbu94qwG/g7ySmwDtxi60uk3UOULYQHnOq87L9V+/WhZyhtXomWUZkAHrGVOTHvH0Hl6ptye5ryRMKZlYPnSlhTA2vT7Nukt4qTvB4E9iM2dA8jTRh2eaCUR4FE+nphgrF7+A16k1gV0n5BwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/switchover_icon_selected.png
// module id = Hk9i
// module chunks = 1